<template>
  <div class="row">
    <div class="col-xl-2 col-lg-4 col-12 px--5">
      <CCard
        :bgColor="activeColor"
        :text="'Attempted Today'"
        :value="obj.attempted_today"
        :cardImg="transactionIcon"
      />
    </div>
    <div class="col-xl-2 col-lg-4 col-12 px--5">
      <CCard
        :bgColor="dangerColor"
        :text="'Failed Today'"
        :value="obj.failed_today"
        :cardImg="transactionIcon"
      />
    </div>
    <div class="col-xl-2 col-lg-4 col-12 px--5">
      <CCard
        :bgColor="'#FBC108'"
        :text="'Successful Last Week'"
        :value="obj.successful_last_week"
        :cardImg="transactionIcon"
      />
    </div>
    <div class="col-xl-2 col-lg-4 col-12 px--5">
      <CCard
        :bgColor="activeColor"
        :text="'Successful This Month'"
        :value="obj.successful_this_month"
        :cardImg="transactionIcon"
      />
    </div>
    <div class="col-xl-2 col-lg-4 col-12 px--5">
      <CCard
        :bgColor="'#FBC108'"
        :text="'Successful This Week'"
        :value="obj.successful_this_week"
        :cardImg="transactionIcon"
      />
    </div>
    <div class="col-xl-2 col-lg-4 col-12 px--5">
      <CCard
        :bgColor="activeColor"
        :text="'Successful Today'"
        :value="obj.successful_today"
        :cardImg="transactionIcon"
      />
    </div>
  </div>
</template>

<script>
import CCard from "@/components/CCard";
import transactionIcon from "@/assets/images/transaction-icon.png";

export default {
  name: "TerminalStats",
  props: {
    obj: {
      type: Object,
      required: true
    }
  },
  components: {
    CCard
  },
  data() {
    return {
      transactionIcon,
      activeColor: "#2CB858",
      dangerColor: "#AF231E",
      textColor: "#001833",
      valueColor: "#001833"
    };
  }
};
</script>

<style></style>
